<template>
  <div class='card block-shadow'>
    <div class="card__title">
      <span>
        {{ cardOptions.name.first }}
      </span>
      <span v-if="cardOptions.name.second">
        <span v-if="!cardOptions.name.detailsLink">{{ cardOptions.name.second }}</span>
        <router-link v-if="cardOptions.name.detailsLink" class="card__title__link"
                     :to="cardOptions.name.detailsLink">
          {{ cardOptions.name.second }}
        </router-link>
      </span>
    </div>
    <div class="card__content">
      <ul v-for='(advantage, index) in cardOptions.advantages' :key="index" class="card__content__product-desc">
        <li class="card__content__product-desc__item">
          <img class="icon" :src="advantage.icon" alt="">
          <span class="text" v-html="advantage.text">
          </span>
        </li>
      </ul>
    </div>
    <div class="card__footer" v-if="cardOptions.cost">
      <div class="card__footer__costs">
        <div v-if='cardOptions.cost.promoCost' class="card__footer__promo-cost flex-shrink-1">
          <span class="cost">
            {{ cardOptions.cost.promoCost }}
          </span>
          <span class="unit">
            {{ cardOptions.cost.unit.currency }}
          </span>
        </div>
        <div class="card__footer__full-cost flex-grow-1" v-bind:class="{'justify-center': !cardOptions.cost.promoCost}">
          <span class="cost">
            {{ cardOptions.cost.fullCost }}
          </span>
          <span>
            <div class="unit">
              {{ cardOptions.cost.unit.currency }}
            </div>
            <div v-if="cardOptions.cost.unit.month">
              <hr>
              <div class="unit">
                {{ cardOptions.cost.unit.month }}
              </div>
            </div>
          </span>
        </div>
      </div>
      <div v-if="cardOptions.details"
           class="card__footer__details-button">
        <v-btn
            small
            class="primary flex-fill"
            :to="'/router550'"
            elevation="2">
          {{ cardOptions.details.button }}
        </v-btn>
      </div>
      <div class="card__footer__note"
           v-bind:style="{color: cardOptions.note.textColor }"
           v-if="cardOptions.note">
        <span v-html="cardOptions.note.text">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardItem",
  props: ['cardOptions']
}
</script>

<style scoped>
.card {
  width: 375px;
  min-height: 427px;
  border-radius: 25px;
  background-color: #f3f3f3;
  overflow: hidden;
}

.card:not(:first-child) {
  margin-left: 30px;
}

.card__title {
  height: 75px;
  padding: 0 15px;
  font-weight: 800;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #e76d82;
  line-height: 30px;
  color: #ffffff;
  font-size: 26px;
}

.card__title__link {
  color: white;
}

.card__content {
  min-height: 300px;
  padding: 35px 35px 0 35px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex
}

.card__content__product-desc__item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin: 0 0 25px 0;
}

.card__content__product-desc__item > .text {
  margin-left: 35px;
  line-height: 24px;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.6);
}

.card__footer {
  margin: 0 20px;
  border-top: 2px solid #cccccc;
  display: flex;
  flex-direction: column;
  /*align-items: center;*/
  justify-content: center;
  /*padding: 15px 0 25px;*/
  padding: 15px 0;
}

.card__footer__costs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.card__footer__promo-cost {
  color: #787878;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 100%;
  max-width: 30%;
  max-height: 100%;
}

.card__footer__promo-cost > .cost {
  position: relative;
  font-size: 24px;
}

.card__footer__promo-cost > .cost:before {
  content: "";
  border-bottom: 1px solid #787878;
  position: absolute;
  width: 100%;
  height: 50%;
  transform: rotate(-12deg);
}

.card__footer__promo-cost .unit {
  font-size: 16px;
}

.card__footer__full-cost {
  color: #db3867;
  display: flex;
  flex-direction: row;
  align-items: center;
  /*flex: 1 1 100%;*/
  line-height: normal;
}

.card__footer__full-cost hr {
  margin: 1px 0 1px 5px;
  padding: 0;
  width: 100%;
  border-top: 1px solid #db3867;
}

.card__footer__full-cost > .cost {
  max-width: 70%;
  font-size: 65px;
  font-weight: 800;
}

.card__footer__full-cost .unit {
  margin-left: 10px;
  font-size: 18px;
}

.card__footer__note {
  min-height: 36px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  color: #787878;
  margin: 10px 0 5px 0;
  font-size: 12px;
}

.card__footer__details-button {
  text-align: center;
  margin: 10px 0;
}

@media (max-width: 800px) {
  .card {
    margin-left: 0 !important;
    width: auto;
    margin-bottom: 15px;
  }

  .card__content {
    padding: 25px 25px 0 25px;
  }

  .card__content__product-desc__item .text {
    font-size: 20px;
    line-height: 24px;
  }
}

@media (max-width: 400px) {
  .card__title {
    font-size: 24px;
  }
}
</style>
